import { Colors } from "@brg/ui";
import { hintToolbarStylesWhite, hintToolbarStylesDark } from "./hintStyles";

interface IToolBarStyle {
    fontFamily?: string,
    fontWeight?: number,
    padding?: string, 
    fontSize?: string, 
    lineHeight?: string, 
    letterSpacing?: string,
    color: string,
    backgroundColor?: string,
    background: string,
    id?: string,
    className?: string,
    textColor?: string
}

export const tooptipStylesWhite = {
    ...hintToolbarStylesWhite,
    textColor: hintToolbarStylesWhite.color,
    id: 'tooltip-parent-element',
    className: 'tooltip-parent-element',
}

export const tooptipStylesDark = {
    ...hintToolbarStylesDark,
    textColor: '#fff',
    id: 'tooltip-parent-element',
    className: 'tooltip-parent-element',
}

export const navbarCreateTooltipProps = {
    id: 'tooltip-navbar-create',
    className: 'tooltip-navbar-create',
}


export const getTooltipStyles = (theme: any): IToolBarStyle => {
    const isDark = ["#000000", Colors.geo ].includes(theme?.app?.backgroundColor);
    return isDark ? tooptipStylesDark : tooptipStylesWhite;
}import { Colors } from "@brg/ui";
import { hintToolbarStylesWhite, hintToolbarStylesDark } from "./hintStyles";

interface IToolBarStyle {
    fontFamily?: string,
    fontWeight?: number,
    padding?: string, 
    fontSize?: string, 
    lineHeight?: string, 
    letterSpacing?: string,
    color: string,
    backgroundColor?: string,
    background: string,
    id?: string,
    className?: string,
    textColor?: string
}

export const tooptipStylesWhite = {
    ...hintToolbarStylesWhite,
    textColor: hintToolbarStylesWhite.color,
    id: 'tooltip-parent-element',
    className: 'tooltip-parent-element',
}

export const tooptipStylesDark = {
    ...hintToolbarStylesDark,
    textColor: '#fff',
    id: 'tooltip-parent-element',
    className: 'tooltip-parent-element',
}

export const navbarCreateTooltipProps = {
    id: 'tooltip-navbar-create',
    className: 'tooltip-navbar-create',
}


export const getTooltipStyles = (theme: any): IToolBarStyle => {
    const isDark = ["#000000", Colors.geo ].includes(theme?.app?.backgroundColor);
    return isDark ? tooptipStylesDark : tooptipStylesWhite;
}